export default {
  methods: {
    getColorCode (user) {
      const TOTAL_COLORS = 7;

      if (
        (user.protocol === 'h323' || user.protocol === 'sip') &&
        user.fromid
      ) {
        const hash = (Number(user.fromid) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (user.protocol === 'webrtc' && user.fromid) {
        const hash =
          Math.abs(
            parseInt(this.hashCode(user.fromid), 10) % TOTAL_COLORS
          ) + 1;
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (user.protocol === 'presence' && user.fromid) {
        const hash =
          (parseInt(user.fromid.substring(0, 10), 16) % TOTAL_COLORS) +
          1;
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (user.alias) {
        let hash = (Number(user.alias) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          hash =
            Math.abs(
              parseInt(this.hashCode(user.alias), 10) % TOTAL_COLORS
            ) + 1;
        }
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (user && user.remoteuser) {
        const hash = (Number(user.remoteuser) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (
        user &&
        user.contact &&
        user.contact.remoteuser
      ) {
        const hash = (Number(user.contact.remoteuser) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (user.userhash) {
        let hash =
          (parseInt(user.userhash.substring(0, 10), 16) %
            TOTAL_COLORS) +
          1;

        if (isNaN(hash)) {
          hash =
            Math.abs(
              parseInt(this.hashCode(user.userhash), 10) % TOTAL_COLORS
            ) + 1;
        }
        return hash;
      }
      if (
        user &&
        user.contact &&
        user.contact.userhash
      ) {
        let hash =
          (parseInt(user.contact.userhash.substring(0, 10), 16) %
            TOTAL_COLORS) +
          1;

        if (isNaN(hash)) {
          hash =
            Math.abs(
              parseInt(this.hashCode(user.contact.userhash), 10) %
                TOTAL_COLORS
            ) + 1;
        }
        if (!isNaN(hash)) {
          return hash;
        }
      }
      if (user.number_short) {
        return (parseInt(user.number_short, 10) % TOTAL_COLORS) + 1;
      }
      if (user.fromid) {
        let hash = (parseInt(user.fromid, 10) % TOTAL_COLORS) + 1;
        if (isNaN(hash)) {
          hash =
            Math.abs(
              parseInt(this.hashCode(user.fromid), 10) % TOTAL_COLORS
            ) + 1;
        }
        if (!isNaN(hash)) {
          return hash;
        }
      }

      if (user.room) {
        const hash = (parseInt(user.room, 10) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          return hash;
        }
      }
      if (user.iscustom) {
        const hash = (parseInt(this.hashCode(user.id), 10) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          return hash;
        }
      }
      if (user.callid) {
        let hash = (Number(user.callid) % TOTAL_COLORS) + 1;
        if (!isNaN(hash)) {
          hash =
            Math.abs(parseInt(this.hashCode(user.callid), 10) % TOTAL_COLORS) +
            1;
        }
        if (!isNaN(hash)) {
          return hash;
        }
      }
      return 0;
    },
    hashCode (str) {
      let hash = 0;
      let i;
      let chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return Math.abs(hash);
    }
  }
};
